import { produce } from 'immer'
import baseReducer from './baseReducer'
import * as Actions from './actions'

const geoNear = {
  maxDistance: 500000,
  location: null
}

const pagination = {
  pageSize: 100,
  pageNumber: 1
}

export const initialState = {
  filters: {
    stores: {
      pagination,
      filter: {
        chain: {
          ids: []
        },
        geoNear
      }
    },
    physicalOffers: {
      pagination,
      filter: {
        chain: {
          ids: []
        },
        advertisementType: [0],
        geoNear
      }
    },
    ecommerceOffers: {
      pagination,
      filter: {
        chain: {
          ids: []
        },
        advertisementType: [1],
        geoNear
      }
    }
  },
  stores: [],
  offers: {
    physicalOffers: [],
    ecommerceOffers: []
  },
  useLocation: false,
  zipCode: null,
  location: {
    latitude: null,
    longitude: null
  }
}

const showCaseReducer = baseReducer(initialState, {
  [Actions.SET_LOCATION] (state, { payload }) {
    return produce(state, draft => {
      draft.filters.stores.filter.geoNear.location = payload
      draft.filters.physicalOffers.filter.geoNear.location = payload
      draft.filters.ecommerceOffers.filter.geoNear.location = payload
      draft.location = payload
    })
  },
  [Actions.SET_ZIPCODE] (state, { payload }) {
    return produce(state, draft => {
      draft.zipCode = payload
    })
  },
  [Actions.SET_USE_LOCATION] (state, { payload }) {
    return produce(state, draft => {
      draft.useLocation = payload
    })
  },
  [Actions.REQUEST_GET_SHOWCASE_STORES_FINISHED] (state, { payload }) {
    return produce(state, draft => {
      draft.stores = payload
    })
  },
  [Actions.REQUEST_GET_SHOWCASE_OFFERS_FINISHED] (state, { payload, meta }) {
    return produce(state, draft => {
      draft.offers[meta] = payload
    })
  },
  [Actions.REQUEST_GET_LOCATION_FROM_ZIP_CODE_FINISHED] (state, { payload }) {
    return produce(state, draft => {
      draft.filters.stores.filter.geoNear.location = payload
      draft.filters.physicalOffers.filter.geoNear.location = payload
      draft.filters.ecommerceOffers.filter.geoNear.location = payload
      draft.location = payload
    })
  }
})

export default showCaseReducer



// WEBPACK FOOTER //
// ./src/features/MeuBairro/showCaseReducer.js